import isClient from 'commons/isClient';

let isCallbackSet = false;

const refreshFinancingContent = () => {
  if (isCallbackSet) {
    // If the callback is already set, we should refresh immediately to avoid
    // waiting for a ready event that has already been triggered (e.g. on a
    // previous PDP or instance of the Cart sidebar).
    window.affirm.ui.refresh?.();
  }

  if (!isCallbackSet && isClient() && window?.affirm?.ui?.ready) {
    isCallbackSet = true;

    window.affirm.ui.ready(() => {
      window.affirm.ui.refresh();
    });
  }
};

export default refreshFinancingContent;
